module.exports = __webpack_public_path__ + "static/media/ebook-nodata2.0350d1f8.png";